import { ComplianceStatus } from '@luminovo/api-contracts';
import { transEnum } from '@luminovo/frontend-utils';

import { ComplianceStatusTranslations } from '../i18n';

export function formatComplianceStatus(status?: ComplianceStatus | null | undefined): string {
    if (!status) {
        return '-';
    }
    return transEnum(status, ComplianceStatusTranslations);
}
